<template>
    <div class="pagination-indicator">
        <input
            v-model="page"
            v-on:keydown="showButton = true"
            v-on:keydown.enter="goPage"
            class="pagination-indicator__page" />

        <span>of {{pagecount}}</span>

        <button
            v-show="showButton"
            class="button button--text pagination-indicator__button"
            v-on:click="goPage">
            Go
        </button>
    </div>
</template>

<script>
    import { ref } from 'vue';

    const params = new window.URLSearchParams(window.location.search);

    export default {
        props : {
            current : Number,
            pagecount : Number
        },

        setup(props) {
            const page = ref(parsePage(
                params.get("pagenr") ? parseInt(params.get("pagenr")) : 1
            ));

            const showButton = ref(false);

            function goPage() {
                const loc = window.location;
                params.set("pagenr", parsePage(page.value));
                console.log(params);
                window.location = `${loc.origin}${loc.pathname}?${params.toString()}`;
            }

            function parsePage(page) {
                // Do some sanity checks on the pagenr and return something that
                // works
                page = parseInt(page);

                if (isNaN(page)) {
                    return 1;
                } else if (page < 1) {
                    return 1;
                } else if (page > props.pagecount) {
                    return props.pagecount;
                } else {
                    return page;
                }
            }

            return { goPage, page, showButton };
        }
    };
</script>